import { Route, Routes } from "react-router-dom"
import { SonometersListAdminView } from "sonometer/admin/views/SonometersListAdminView"
import SonometerAdminView from "../admin/views/SonometerAdminView"
export function SonometerAdminRoutes() {
    return (
        <Routes>
            <Route path="" element={<SonometersListAdminView />} />
            <Route
                path="new"
                element={<SonometerAdminView isCreateMode={true} />}
            />
            <Route path=":sonometerId">
                <Route
                    path=""
                    element={<SonometerAdminView isCreateMode={false} />}
                />
            </Route>
            <Route path=":sonometerId/duplicate">
                <Route
                    path=""
                    element={<SonometerAdminView isCreateMode={false} />}
                />
            </Route>
        </Routes>
    )
}
